import createAxios from "../services/httpCommon";

// export const fetchProducts = async ({ page = 1, size = 20, search = "" }) => {
//   try {
//     const axios = await createAxios();
//     let url = `/product?page=${page}&size=${size}`;
//     if (search) url += `&search=${encodeURIComponent(search)}`;
//     const response = await axios.get(url);

//     const data = response?.data?.data || {};
//     const products = Array.isArray(data?.products) ? data.products : [];

//     const initializedProducts = products.map((p) => ({
//       ...p,
//       quantity: p.quantity ?? 0,
//     }));

//     return {
//       ...data,
//       products: initializedProducts,
//     };
//   } catch (error) {
//     throw error;
//   }
// };

export const fetchProducts = async ({
  page = 1,
  size = 20,
  categoryId,
  search = "",
}) => {
  try {
    const axios = await createAxios();
    let url = `/product?page=${page}&size=${size}`;

    if (categoryId) url += `&categoryId=${categoryId}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;

    const response = await axios.get(url);

    const data = response?.data?.data || {};
    const products = Array.isArray(data?.products) ? data.products : [];

    const initializedProducts = products.map((p) => ({
      ...p,
      quantity: p.quantity ?? 0,
    }));

    return {
      ...data,
      products: initializedProducts,
    };
  } catch (error) {
    throw error;
  }
};

export const fetchGlobalProducts = async () => {
  try {
    const axios = await createAxios();
    const response = await axios.get("/product");
    const data = response?.data?.data;

    const products = Array.isArray(data?.products)
      ? data.products
      : Array.isArray(data)
        ? data
        : [];

    const initializedProducts = products.map((p) => ({
      ...p,
      quantity: p.quantity ?? 0,
    }));

    return initializedProducts;
  } catch (error) {
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const axios = await createAxios();
    const response = await axios.get("/product/category");
    return response?.data?.categories?.categories || [];
  } catch (error) {
    throw error;
  }
};

export const fetchTrendingProducts = async () => {
  try {
    const axios = await createAxios();
    const response = await axios.get("/product/trending");
    const data = response?.data;

    const products = Array.isArray(data)
      ? data
      : Array.isArray(data)
        ? data
        : [];

    const initializedProducts = products.map((p) => ({
      ...p,
      quantity: p.quantity ?? 0,
    }));

    return initializedProducts;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchCategoryProducts = async (categoryId) => {
  if (!categoryId) return [];
  try {
    const axios = await createAxios();
    const response = await axios.get(`/product?categoryId=${categoryId}`);

    const data = response?.data?.data?.products || [];

    return data.map((p) => ({
      ...p,
      quantity: p.quantity ?? 0,
    }));
  } catch (error) {
    throw error;
  }
};

export const fetchGlobalBoxes = async () => {
  try {
    const axios = await createAxios();
    const response = await axios.get("/subscription/box");
    const data = response?.data?.data;

    const boxes = Array.isArray(data) ? data : Array.isArray(data) ? data : [];

    const initializedBoxes = boxes.map((p) => ({
      ...p,
      quantity: p.quantity ?? 0,
    }));

    return initializedBoxes;
  } catch (error) {
    throw error;
  }
};

export const fetchUserBoxes = async () => {
  const axios = await createAxios();
  const response = await axios.get("/subscription/me");
  const data = response?.data?.data;
  const boxes = Array.isArray(data) ? data : [];
  return boxes;
};

export const fetchBoxById = async (boxId) => {
  if (!boxId) return null;
  try {
    const axios = await createAxios();
    const response = await axios.get(`/subscription/box/${boxId}`);
    return response?.data?.data || null;
  } catch (error) {
    throw error;
  }
};
export const fetchCompareProducts = async ({
  productIds = [],
  boxIds = [],
}) => {
  if (productIds.length === 0 && boxIds.length === 0)
    return { products: [], boxes: [] };
  try {
    const axios = await createAxios();
    const response = await axios.post("/product/compare", {
      productIds,
      boxIds,
    });
    return (
      response?.data?.data || response?.data || { products: [], boxes: [] }
    );
  } catch (error) {
    throw error;
  }
};
